import Button from "../../components/Button";
import Icon from "../../components/Icon";

export default function NoPatientConsentModal({
    isOpen,
    onClose,
}) {
    if (!isOpen) return null;

    return (
        <div className="modal-scroll modal-scroll-no-outer">
            <div className="modal-dialog bg-main-background-system-default w-[390px] rounded-xl px-5 py-6 gap-7 flex flex-col items-center justify-center">
                <div className="flex flex-col items-center justify-center gap-5">
                    <div className="w-9 h-9 rounded-lg p-2 gap-3 flex items-center justify-center bg-main-background-accented-warning">
                        <Icon
                            name="exclamation"
                            size="xl"
                            className="text-main-icon-accented-warning"
                        />
                    </div>
                    <div className="flex flex-col items-center justify-center gap-3">
                        <p className="font-ui font-header text-title text-main-typography-system-default">ผู้ป่วยยังไม่ได้ยินยอมรับการรักษา</p>
                        <p className="font-ui font-body text-body-base text-main-typography-system-description text-center">โปรดแจ้งผู้ป่วยดำเนินการยินยอม<br />หนังสือยินยอมรับการตรวจและรักษาทั่วไป<br />และการเก็บรวบรวม ก่อนดำเนินการต่อไป</p>
                    </div>
                </div>
                <div className="w-full">
                    <Button
                        hierarchy="primary"
                        size="md"
                        text="ย้อนกลับ"
                        className="w-full h-12 text-lg"
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    );
}
